import { Box } from '@mui/material';
import LoadingOverlay from 'components/shared/LoadingOverlay';
import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';
import type { HoursPayOutRequestResponse } from 'generated/index';
import { toNativeDate } from 'utils/date';
import Header from './components/Header';
import useColumnDefinitions from './useColumnDefinitions';
import { usePlanUnitSelection } from './hooks/usePlanUnitSelection';
import { usePeriodAndDateState } from './hooks/usePeriodAndDateState';
import { useDateRangeCalculation } from './hooks/useDateRangeCalculation';
import { useHoursPayOutData } from './hooks/useHoursPayOutData';

const HoursPayOutRequestsOverview = () => {
  'use memo';

  const columns = useColumnDefinitions();

  const { setSelectedPlanUnits, organizationalUnitIds } =
    usePlanUnitSelection();

  const {
    period,
    setPeriod,
    selectedDate,
    setSelectedDate,
    selectedDateRange,
    setSelectedDateRange
  } = usePeriodAndDateState();

  const dateRange = useDateRangeCalculation({
    period,
    selectedDate,
    selectedDateRange
  });

  const { rows, isLoading, isError, refetch, onlyToApprove, setOnlyToApprove } =
    useHoursPayOutData({
      dateRange,
      organizationalUnitIds
    });

  return (
    <>
      <Header
        selectedDate={selectedDate}
        selectedDateRange={selectedDateRange}
        period={period}
        onlyToApprove={onlyToApprove}
        onPeriodChange={setPeriod}
        onSelectedDate={setSelectedDate}
        onSelectedDateRange={(dateRange) =>
          setSelectedDateRange([
            toNativeDate(dateRange?.[0]),
            toNativeDate(dateRange?.[1])
          ])
        }
        onSelectPlanUnit={setSelectedPlanUnits}
        onOnlyToApproveChange={setOnlyToApprove}
      />
      <Box>
        <TableCRUDLayout<HoursPayOutRequestResponse>
          rows={rows}
          columns={columns}
          hasLoadingError={isError}
          onLoadingError={refetch}
          translationKey="hoursPayOutRequestsOverview.emptyState"
          editable={false}
          pageSize={50}
          pageSizeOptions={[25, 50, 100]}
          hideFooter={rows.length === 0}
          dynamicHeight
          initialState={{
            sorting: {
              sortModel: [{ field: 'requestDate', sort: 'asc' }]
            }
          }}
        />
      </Box>
      <LoadingOverlay loading={isLoading} />
    </>
  );
};

export default HoursPayOutRequestsOverview;
